/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class TombstoneIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xNudge: true,
        volatility: Volatility.EXTREME
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/introBackground.jpg");
        imgLoader.add("introPage", "resources/images/introPage.png");
        imgLoader.add("newIntroLogo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return <GameIntroViewConfig>this;
        });
    }

    private initGraphics() {
        return new Promise((resolve, reject) => {
            this.background = new PIXI.Container();
            const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
            bgSprite.anchor.set(0.5, 0.5);
            this.background.addChild(bgSprite);

            this.borderTop = new PIXI.Container();
            this.borderBottom = new PIXI.Container();

            this.logo = new PIXI.Container();
            const logoSprite =  new PIXI.Sprite(ImgLoader.getImgTexture("newIntroLogo"));
            logoSprite.anchor.set(0.5, 0.5);
            this.logo.addChild(logoSprite);


            const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture("introPage"));
            featureSprite1.name = "Features_1";
            featureSprite1.anchor.set(0.5, 0.5);

            this.pages = [
                new SlideShowPage(),

            ];

            this.pages[0].addChild(featureSprite1);

        });

    }



}